import { useTrial } from "../../context/TrialContext";
import { X, Building2, MapPin, ClipboardList, RotateCcw, Bot, ArrowRight } from "lucide-react";

const ICONS = {
  Department: Building2,
  Location: MapPin,
  "Bia Process": ClipboardList,
  "Recovery Plan": RotateCcw,
  "Ai Query": Bot,
};

export const TrialSoftWall = () => {
  const { showUpgradeModal, upgradeContext, dismissUpgradeModal } = useTrial();

  if (!showUpgradeModal || !upgradeContext) return null;

  const { resourceLabel, current, limit } = upgradeContext;
  const Icon = ICONS[resourceLabel] || ClipboardList;

  return (
    <div
      data-testid="trial-soft-wall-overlay"
      className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[60] flex items-center justify-center p-4"
      onClick={dismissUpgradeModal}
    >
      <div
        data-testid="trial-soft-wall-modal"
        className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          data-testid="soft-wall-close-btn"
          onClick={dismissUpgradeModal}
          className="absolute top-4 right-4 text-slate-400 hover:text-slate-600"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="text-center">
          <div className="w-14 h-14 bg-amber-100 rounded-full mx-auto flex items-center justify-center mb-4">
            <Icon className="w-7 h-7 text-amber-600" />
          </div>

          <h3 className="font-bold text-lg text-slate-900 mb-1">
            You've reached {current} of {limit} trial {resourceLabel.toLowerCase()}s
          </h3>

          <p className="text-sm text-slate-500 mb-6">
            Upgrade to add unlimited {resourceLabel.toLowerCase()}s &mdash; your existing data carries over instantly. No re-entry required.
          </p>

          <button
            data-testid="soft-wall-upgrade-btn"
            className="bg-amber-500 hover:bg-amber-600 text-white font-bold text-sm px-6 py-3 rounded-full transition inline-flex items-center gap-2"
          >
            Upgrade to Continue
            <ArrowRight className="w-4 h-4" />
          </button>

          <p className="text-xs text-slate-400 mt-4">
            Starting at $0.50/user/day &mdash; less than a coffee round for your team.
          </p>
        </div>
      </div>
    </div>
  );
};
